module.exports = __webpack_public_path__ + "static/media/portfolio-banner-info-img1.933f4134.png";